import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    totalTvCount: 10, // The TV inventory
    curDeviceId: null,
    curDeviceName: null,
    curTrainNo: null,
    curTrainDate: null,
    curOrg: null,
    curArr: null,
    curDest: null,
    curDep: null,
    actDep: null,
    actArr: null,
    curUser: null,
    curPosStartId: 0,
    curPosDestId: 0,
    summary: {"Puctuality": 0},
    curStartDate: null,
    curEndDate: null,
    curCrewId: null,
    curStartTime: null,
    curEndTime: null,
    curPositions:[],
    curLiveStn: null,
    msg: {
     calcStartedAt: null,
     calcCompletedAt: null,
     noOfTrainsCalcCTRsofar: 0,
     calcualtingAllCTR: false
   },
  },

  getters: {
    // Here we will create a getter
  },

  mutations: {
    updateCurDeviceId(state, valueToUpdate) {
      state.curDeviceId = valueToUpdate
    },
    updateCurDeviceName(state, valueToUpdate) {
      state.curDeviceName = valueToUpdate
    },
    updateCurTrainNo(state, valueToUpdate) {
      state.curTrainNo = valueToUpdate
    },
    updateCurTrainDate(state, valueToUpdate) {
      state.curTrainDate = valueToUpdate
    },
    updateCurOrg(state, valueToUpdate) {
      state.curOrg = valueToUpdate
    },
    updateCurArr(state, valueToUpdate) {
      state.curArr = valueToUpdate
    },
    updateCurDest(state, valueToUpdate) {
      state.curDest = valueToUpdate
    },
    updateCurDep(state, valueToUpdate) {
      state.curDep = valueToUpdate
    },
    updateActDep(state, valueToUpdate) {
      state.actDep = valueToUpdate
    },
    updateActArr(state, valueToUpdate) {
      state.actArr = valueToUpdate
    },
    updateCurUser(state, valueToUpdate) {
      state.curUser = valueToUpdate
    },
    updateCurPosStartId(state, valueToUpdate) {
      state.curPosStartId = valueToUpdate
    },
    updateCurPosDestId(state, valueToUpdate) {
      state.curPosDestId = valueToUpdate
    },
    updateSummary(state, valueToUpdate) {
      state.summary = valueToUpdate
    },
    updateCurStartDate(state, valueToUpdate) {
      state.curStartDate = valueToUpdate
    },
    updateCurEndDate(state, valueToUpdate) {
      state.curEndDate = valueToUpdate
    },
    updateCurCrewId(state, valueToUpdate) {
      state.curCrewId = valueToUpdate
    },
    updateCurStartTime(state, valueToUpdate) {
      state.curStartTime = valueToUpdate
    },
    updateCurEndTime(state, valueToUpdate) {
      state.curEndTime = valueToUpdate
    },
    updateCurPositions(state, valueToUpdate) {
      state.curPositions = valueToUpdate
    },
    updateCTRmsg(state, valueToUpdate) {
      state.msg = valueToUpdate
    },
  },

  actions: {
    updateCurDeviceId(context, valueToUpdate) {
      context.commit('updateCurDeviceId', valueToUpdate)
    },
    updateCurDeviceName(context, valueToUpdate) {
      context.commit('updateCurDeviceName', valueToUpdate)
    },
    updateCurTrainNo(context, valueToUpdate) {
      context.commit('updateCurTrainNo', valueToUpdate)
    },
    updateCurTrainDate(context, valueToUpdate) {
      context.commit('updateCurTrainDate', valueToUpdate)
    },
    updateCurOrg(context, valueToUpdate) {
      context.commit('updateCurOrg', valueToUpdate)
    },
    updateCurArr(context, valueToUpdate) {
      context.commit('updateCurArr', valueToUpdate)
    },
    updateCurDest(context, valueToUpdate) {
      context.commit('updateCurDest', valueToUpdate)
    },
    updateCurDep(context, valueToUpdate) {
      context.commit('updateCurDep', valueToUpdate)
    },
    updateActDep(context, valueToUpdate) {
      context.commit('updateActDep', valueToUpdate)
    },
    updateActArr(context, valueToUpdate) {
      context.commit('updateActArr', valueToUpdate)
    },
    updateCurUser(context, valueToUpdate) {
      context.commit('updateCurUser', valueToUpdate)
    },
    updateCurPosStartId(context, valueToUpdate) {
      context.commit('updateCurPosStartId', valueToUpdate)
    },
    updateCurPosDestId(context, valueToUpdate) {
      context.commit('updateCurPosDestId', valueToUpdate)
    },
    updateSummary(context, valueToUpdate) {
      context.commit('updateSummary', valueToUpdate)
    },
    updateCurStartDate(context, valueToUpdate) {
      context.commit('updateCurStartDate', valueToUpdate)
    },
    updateCurEndDate(context, valueToUpdate) {
      context.commit('updateCurEndDate', valueToUpdate)
    },
    updateCurCrewId(context, valueToUpdate) {
      context.commit('updateCurCrewId', valueToUpdate)
    },
    updateCurStartTime(context, valueToUpdate) {
      context.commit('updateCurStartTime', valueToUpdate)
    },
    updateCurEndTime(context, valueToUpdate) {
      context.commit('updateCurEndTime', valueToUpdate)
    },
    updateCurPositions(context, valueToUpdate) {
      context.commit('updateCurPositions', valueToUpdate)
    },
    updateCTRmsg(context, valueToUpdate) {
      context.commit('updateCTRmsg', valueToUpdate)
    },
  }
});
